import useQuery from "hooks/useQuery";
import { useEffect } from "react";
import { showErrorModal } from "utils";
import { getAdicional } from "../../api";

const useGetAdicional = (precioId) => {
  const { data, loading, refetch } = useQuery({
    autoFetch: false,
    queryFn: getAdicional,
    onError: (err) => showErrorModal({ err }),
  });

  const fetch = (precioId) => {
    refetch(precioId);
  }

  useEffect(() => {
    if (!precioId) return;
    fetch(precioId);
  }, [precioId]);

  return {
    grupos: data?.data?.adicionales?.grupos,
    articulos: data?.data?.adicionales?.articulos,
    unidades: data?.data?.adicionales?.unidades,
    loadingAdicionales: loading,
    fetchAdicionales: fetch,
  }
}

export default useGetAdicional;